import { DEFAULT_STRUCTURE } from '../constants';

export type OrganizationMapperResult = ReturnType<typeof organizationMapper>;

export type OrganizationMapperParams = {
  logo: string;
  url: string;
  name: string;
};

export const organizationMapper = ({
  logo,
  url,
  name,
}: OrganizationMapperParams) => ({
  ...DEFAULT_STRUCTURE,
  '@type': 'Organization' as const,
  url,
  logo,
  name,
});
